var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (Boolean(_vm.sku))?_c('div',{staticClass:"view-product"},[_c('CProduct',{attrs:{"sku":_vm.sku}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }